// extracted by mini-css-extract-plugin
export default {"container":"LoginWithGooglePage_container__Wt6vA"};